import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import translate from '../../commonComponents/translate';
import { useScrollAnchor } from '../../services/customHooks';
import SessionList from './list/SessionList';
import CategoryProp from '../academy/propTypes/categoryProp';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import CurrencyProp from '../profile/propTypes/currencyProp';
import SessionsCarouselItem from './SessionsCarouselItem';
import SessionFilters from './list/SessionFilters';
import ServerSideCarousel from '../../commonComponents/carousel/ServerSideCarousel';
import LoggedUserContext from '../../contextProviders/LoggedUserContext';
import PriceRangeProp from '../academy/propTypes/PriceRangeProp';
import Notifications from '../../services/notifications';

const fetchMySessionsTotal = async () => {
  const url = '/api/access-session/list?enrolled=true';
  const params = {
    index: 1,
  };
  const { data } = await axios.get(url, {
    params,
    headers: {
      'Accept-Version': '1.0.0',
      'X-Gamification-API': 'Games',
    },
  });

  return data.total;
};

function Sessions(props) {
  const { t, categories, languages, currencies, applyFilters, priceRange } =
    props;

  const { contentElement, scrollToContent } = useScrollAnchor();

  const [mySessions, setMySessions] = useState(0);
  const [query, setQuery] = useState({
    category: '',
    language: '',
    certificate: undefined,
    price: priceRange.max || undefined,
    search: '',
    status: '',
    type: '',
  });
  useEffect(() => {
    if (applyFilters) {
      if (
        localStorage.getItem('sessionFilter') &&
        localStorage.getItem('sessionFilter').length > 0
      ) {
        setQuery(JSON.parse(localStorage.getItem('sessionFilter')));
      }
    } else {
      localStorage.removeItem('sessionFilter');
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('sessionFilter', JSON.stringify(query));
  }, [query]);

  const handleQueryChange = value => {
    setQuery(q => ({ ...q, ...value }));
    scrollToContent();
  };
  const { loggedUser } = useContext(LoggedUserContext);

  const handleChange = field => value => {
    setQuery(q => ({ ...q, [field]: value }));
    scrollToContent();
  };

  useEffect(() => {
    fetchMySessionsTotal()
      .then(total => {
        setMySessions(total);
      })
      .catch(err => {
        Notifications.showErrorFromRequest(err);
      });
  }, [setMySessions]);

  return (
    <>
      {loggedUser && mySessions > 0 && (
        <>
          <h4 className="sessions-subtitle-title">{t('mySessions_title')}</h4>
          <div className="m-portlet__body related-container">
            <ServerSideCarousel
              id="my-sessions-carousel"
              fetchUrl="/table/access-session/list?enrolled=true&populate=trainer&populate=host"
              defaultFetchError="error_fetchSessions"
            >
              {items =>
                items.map(session => (
                  <SessionsCarouselItem
                    key={session._id}
                    className="related-course-item session-carousel-item"
                    session={session}
                  />
                ))
              }
            </ServerSideCarousel>
            <h4 className="sessions-subtitle-title available-sessions">
              {t('sessions_availableSessions')}
            </h4>
          </div>
        </>
      )}
      <div className="row">
        <div className="col-lg-3 filters-shop-desktop">
          <SessionFilters
            currencies={currencies}
            languages={languages}
            categories={categories}
            selected={query}
            onPriceChange={handleChange}
            onChange={handleQueryChange}
            priceRange={priceRange}
          />
        </div>
        <div className="col-lg-9" ref={contentElement}>
          <SessionList
            query={query}
            languages={languages}
            onChange={handleChange}
            currencies={currencies}
            categories={categories}
            onQueryChange={handleQueryChange}
            priceRange={priceRange}
          />
        </div>
      </div>
    </>
  );
}

Sessions.propTypes = {
  t: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape(CategoryProp.propType))
    .isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
  applyFilters: PropTypes.bool,
  priceRange: PropTypes.shape(PriceRangeProp.propType).isRequired,
};

Sessions.defaultProps = {
  applyFilters: false,
};

export default translate(Sessions);
